if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");

        if (this.formInput) {
          this.formInput.disabled = false;
        }

        this.form?.addEventListener(
          "submit",
          this.onSubmitHandler.bind(this)
        );

        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset?.cartType;

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (this.cart && this.submitButton) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton =
          this.disableLoadingInButton.bind(this);
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay"
        );

        if (
          this.body?.classList.contains("quick-buy-page-overlay")
        ) {
          this.body.classList.remove("quick-buy-page-overlay");
        }

        if (
          complementaryOverlayPage?.classList.contains(
            "wt__quick-buy--page-overlay--open"
          )
        ) {
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open"
          );
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.form || !this.submitButton) {
          console.error(
            "ProductForm: formulaire ou bouton submit introuvable."
          );
          return;
        }

        if (
          this.submitButton.getAttribute("aria-disabled") === "true"
        ) {
          return;
        }

        this.handleErrorMessage();

        if (
          typeof this.cart?.setActiveElement === "function"
        ) {
          this.cart.setActiveElement(document.activeElement);
        }

        const loader = this.querySelector(
          ".loading-overlay__spinner"
        );

        this.submitButton.setAttribute("aria-disabled", "true");
        this.submitButton.classList.add("loading");

        if (loader) {
          loader.classList.remove("hidden");
        }

        const config = fetchConfig("javascript");

        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        if (
          typeof this.cart?.getSectionsToRender === "function"
        ) {
          const sections = this.cart
            .getSectionsToRender()
            .map((section) => section.id);

          if (sections.length) {
            formData.append("sections", sections);
            formData.append(
              "sections_url",
              window.location.pathname
            );
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (!response.ok) {
              return response.json().then((data) => {
                throw {
                  shopifyError: true,
                  response: data,
                };
              });
            }

            return response.json();
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors:
                  response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(
                response.description ||
                  response.message ||
                  "Impossible d'ajouter ce produit au panier."
              );

              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(
                  ".sold-out-message"
                );

              if (!soldOutMessage) {
                return;
              }

              this.submitButton.setAttribute(
                "aria-disabled",
                "true"
              );

              const buttonText =
                this.submitButton.querySelector("span");

              buttonText?.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");

              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            }

            this.error = false;

            const quickAddModal =
              this.closest("quick-add-modal");

            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(response);
                  });
                },
                { once: true }
              );

              if (
                this.cartType === "drawer" &&
                typeof quickAddModal.hide === "function"
              ) {
                quickAddModal.hide(true);
              }
            } else {
              const isClosedCart =
                !document.body.classList.contains(
                  "page-overlay-cart-on"
                );

              this.redirectAfterSubmit(
                response,
                isClosedCart
              );
            }
          })
          .catch((error) => {
            console.error(
              "Erreur lors de l'ajout au panier :",
              error
            );

            if (error?.shopifyError) {
              const response = error.response;

              this.handleErrorMessage(
                response?.description ||
                  response?.message ||
                  "Impossible d'ajouter ce produit au panier."
              );

              this.error = true;
              return;
            }

            this.handleErrorMessage(
              "Une erreur est survenue lors de l'ajout au panier."
            );

            this.error = true;
          })
          .finally(() => {
            if (this.cartType === "page") {
              this.disableLoadingInButton();
              return;
            }

            this.disableLoadingInButton();

            if (
              this.cart?.classList.contains("is-empty")
            ) {
              this.cart.classList.remove("is-empty");
            }

            if (!this.error) {
              this.submitButton?.removeAttribute(
                "aria-disabled"
              );
            }

            if (this.error) {
              return;
            }

            this.quick_add_container =
              document.querySelector(
                ".wt__quick-buy__container"
              );

            this.quick_add_overlay =
              document.querySelector(
                ".wt__quick-buy--page-overlay"
              );

            this.quick_add_product =
              this.quick_add_container?.querySelector(
                ".wt-product"
              );

            this.loader =
              this.quick_add_container?.querySelector(
                ".wt__quick-buy-loader"
              );

            if (
              this.quick_add_container &&
              !this.quick_add_container.classList.contains(
                "hidden"
              )
            ) {
              this.quick_add_product?.remove();

              this.quick_add_container.classList.remove(
                "wt__quick-buy__container--open"
              );

              this.quick_add_overlay?.classList.remove(
                "wt__quick-buy--page-overlay--open"
              );

              document.body.classList.remove(
                "quick-buy-page-overlay"
              );

              this.loader?.classList.remove("hidden");
            }
          });
      }

      disableLoadingInButton() {
        if (!this.submitButton) return;

        this.submitButton.classList.remove("loading");

        const loader = this.querySelector(
          ".loading-overlay__spinner"
        );

        loader?.classList.add("hidden");
      }

      redirectAfterSubmit(
        response,
        isClosedCart = true
      ) {
        const body = document.body;
        const isCartPage =
          body.classList.contains("template-cart");

        if (
          this.cartType === "drawer" &&
          isCartPage
        ) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay"
          );

          overlay?.classList.remove(
            "wt__quick-buy--page-overlay--open"
          );

          body.classList.remove(
            "quick-buy-page-overlay"
          );

          window.location =
            window.routes.cart_url;

          return;
        }

        if (
          this.cartType === "drawer" &&
          typeof this.cart?.renderContents === "function"
        ) {
          this.cart.renderContents(
            response,
            isClosedCart
          );

          return;
        }

        window.location = window.routes.cart_url;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            ".product-form__error-message-wrapper"
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute(
          "hidden",
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }
    }
  );
}